import { Fragment } from 'react';
import { Skeleton } from '@mui/material';

export const ReceptionFeatureItemSkeletons = () => (
  <Fragment>
    {Array.from(Array(7), (_, index) => (
      <Skeleton key={index} variant="text" width="100%" height={48} sx={{ transform: 'none' }} />
    ))}
  </Fragment>
);
